// extracted by mini-css-extract-plugin
export default {"container":"notifications_container__CwGRQ","bage":"notifications_bage__AvCFn","notificationButton":"notifications_notificationButton__1JTyk"};